import { useEffect, useState } from 'react';
import $ from 'jquery';
import GbitTableCell from './GbitTableCell';

const GbitTableRow = ({
  tableName,
  headerInfo,
  rowData,
  rowClick,
  rowChange,
}) => {
  const [refinedRow, setRefinedRow] = useState([]);

  const init = async () => {
    let rowDataCopy = await $.extend(true, {}, rowData);
    let modifedRow = [];

    const headerCnt = headerInfo.length;
    for (let index = 0; index < headerCnt; index++) {
      let oneCell = {
        tableName: '',
        rowNo: 0,
        colNo: 0,
        key: '',
        type: '',
        option: '',
        value: '',
        readonly: false,
        auto: false,
        arrow: null,
        maxLength: null,
      };

      const oneHeaderCell = headerInfo.filter(
        header => header.colNo === index
      )[0];

      oneCell.tableName = tableName;
      oneCell.rowNo = rowDataCopy.rowNo;
      oneCell.colNo = index;
      oneCell.key = oneHeaderCell.key;
      oneCell.type = oneHeaderCell.dataType;
      oneCell.option = oneHeaderCell?.dataOption;
      oneCell.value = rowDataCopy[oneCell.key];
      oneCell.readonly = oneHeaderCell.readonly;
      oneCell.maxLength = oneHeaderCell.maxLength;

      modifedRow.push(oneCell);
    }

    setRefinedRow(modifedRow);
  };

  const clickEvt = info => {
    rowClick(info);
  };

  const changeEvt = (info, value) => {
    // let temp = { ...refinedRow };
    // temp.value = value;
    rowChange(info, value);
  };

  useEffect(() => {
    init();
    return () => {};
  }, [rowData]);

  return (
    <tr>
      {refinedRow.length > 0 ? (
        refinedRow.map(cell => {
          return (
            <GbitTableCell
              key={cell.colNo}
              cellInfo={cell}
              cellClick={info => clickEvt(info)}
              cellChange={(info, value) => {
                changeEvt(info, value);
              }}
            />
          );
        })
      ) : (
        <></>
      )}
    </tr>
  );
};

export default GbitTableRow;
